<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
                 <el-form-item label="手机号码:" prop="memberMobile">
                     <el-input v-model="dataForm.memberMobile" :readonly="true" placeholder="手机号码"></el-input>
                 </el-form-item>
                 <el-form-item label="会员名称:" prop="memberName">
                     <el-input v-model="dataForm.memberName" :readonly="true" placeholder="会员名称"></el-input>
                 </el-form-item>
                 <el-form-item label="兑换类型" prop="type">
                     <el-select v-model="dataForm.type" placeholder="请选择兑换类型">
                         <el-option label="全选" value="" key=""></el-option>
                         <el-option
                                 v-for="item in tranCodeList"
                                 :key="item.key"
                                 :label="item.value"
                                 :value="item.key">
                         </el-option>
                     </el-select>
                 </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"  @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce"
    export default {
        data() {
            return {
                visible: false,
                active:0,
                viewStatus:false,
                tranCodeList:[
                    {key:"cash", value:"现金"},
                    {key:"rentCash", value:"租金"},
                    {key:"shareCash", value:"分红现金"},
                    {key:"todoShare", value:"待分红"},
                ],
                dataForm: {
                    memberId: '',
                    memberName:'',
                    memberMobile:'',
                    type:''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                this.visible = true
                this.$nextTick(() => {
                    //this.$refs['dataForm'].resetFields()
                    this.dataForm.id=id;
                    this.getMemberInfo();
                })
            },
            // 获取信息
            getMemberInfo() {
                this.$http.get(`/ums/memberbalance/getByMemberId/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.memberId=res.data.memberId;
                    this.dataForm.memberName=res.data.memberName;
                    this.dataForm.memberMobile=res.data.mobileNumber;
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                console.log(this.dataForm.transferMobile);
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }

                    this.$http['put']('/ums/memberbalance/memberTransferStock', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
